/* eslint-disable react/prop-types */
import { FormControl, FormHelperText, InputLabel, OutlinedInput, InputAdornment } from '@mui/material';
import { useField } from 'formik';
import PropTypes from 'prop-types';

const TextField = ({
  label,
  sx,
  helperText,
  size = 'medium',
  isRequired = false,
  onChange, // Added onChange prop
  InputProps = {}, // Added InputProps to pass endAdornment
  ...props
}) => {
  const [field, meta] = useField(props);

  const handleInputChange = (event) => {
    const { value } = event.target;
    if (onChange) {
      onChange(event); // Trigger the external onChange
    }
    field.onChange(event); // Formik's internal handler
  };

  return (
    <FormControl
      fullWidth
      error={Boolean(meta.touched && meta.error)}
      sx={sx}
      size={size}
    >
      <InputLabel htmlFor={`outlined-adornment-${field.name}`}>
        {label} {isRequired ? '*' : ''}
      </InputLabel>
      <OutlinedInput
        {...field}
        {...props}
        label={label}
        value={field.value ?? ''}
        onChange={handleInputChange}
        inputProps={props.inputProps}
        endAdornment={InputProps.endAdornment} // Pass endAdornment from InputProps
      />
      {!meta.error && helperText && (
        <FormHelperText id={`standard-weight-helper-${field.name}`}>
          {helperText}
        </FormHelperText>
      )}
      {meta.touched && meta.error && (
        <FormHelperText error id={`helper-text-${field.name}`}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  sx: PropTypes.object,
  helperText: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  InputProps: PropTypes.object, // Added prop type for InputProps
};

export default TextField;
